import app from '../../admin/app';
import Component from '../../common/Component';
import PermissionDropdown from './PermissionDropdown';
import Button from '../../common/components/Button';
import ItemList from '../../common/utils/ItemList';
import Icon from '../../common/components/Icon';
import extractText from '../../common/utils/extractText';
export default class PermissionGrid extends Component {
  view(vnode) {
    const scopes = this.scopeItems().toArray();
    const permissionCells = permission => {
      return scopes.map(scope => {
        // This indicates the "permission" is a permission category,
        // in which case we return an empty table cell.
        if ('children' in permission) {
          return m("td", null);
        }
        return m("td", null, scope.render(permission));
      });
    };
    return m("table", {
      className: "PermissionGrid"
    }, m("thead", null, m("tr", null, m("th", null), scopes.map(scope => m("th", null, scope.label, ' ', !!scope.onremove && m(Button, {
      icon: "fas fa-times",
      className: "Button Button--text PermissionGrid-removeScope",
      "aria-label": app.translator.trans('core.admin.permissions.remove_scope_label', {
        scope: scope.label
      }),
      onclick: () => {
        const message = extractText(app.translator.trans('core.admin.permissions.remove_scope_confirmation', {
          scope: scope.label
        }));
        if (confirm(message)) {
          var _scope$onremove;
          (_scope$onremove = scope.onremove) == null || _scope$onremove.call(scope);
        }
      }
    }))), m("th", null, this.scopeControlItems().toArray()))), this.permissionItems().toArray().map(section => m("tbody", null, m("tr", {
      className: "PermissionGrid-section"
    }, m("th", null, section.label), permissionCells(section), m("td", null)), section.children.map(child => m("tr", {
      className: "PermissionGrid-child"
    }, m("th", null, m(Icon, {
      name: child.icon
    }), child.label), permissionCells(child), m("td", null))))));
  }
  permissionItems() {
    const items = new ItemList();
    items.add('view', {
      label: app.translator.trans('core.admin.permissions.read_heading'),
      children: this.viewItems().toArray()
    }, 100);
    items.add('start', {
      label: app.translator.trans('core.admin.permissions.create_heading'),
      children: this.startItems().toArray()
    }, 90);
    items.add('reply', {
      label: app.translator.trans('core.admin.permissions.participate_heading'),
      children: this.replyItems().toArray()
    }, 80);
    items.add('moderate', {
      label: app.translator.trans('core.admin.permissions.moderate_heading'),
      children: this.moderateItems().toArray()
    }, 70);
    return items;
  }
  viewItems() {
    const items = new ItemList();
    items.merge(app.registry.getAllPermissions('view'));
    return items;
  }
  startItems() {
    const items = new ItemList();
    items.merge(app.registry.getAllPermissions('start'));
    return items;
  }
  replyItems() {
    const items = new ItemList();
    items.merge(app.registry.getAllPermissions('reply'));
    return items;
  }
  moderateItems() {
    const items = new ItemList();
    items.merge(app.registry.getAllPermissions('moderate'));
    return items;
  }
  scopeItems() {
    const items = new ItemList();
    items.add('global', {
      label: app.translator.trans('core.admin.permissions.global_heading'),
      render: item => {
        if ('setting' in item) {
          var _item$setting;
          return (_item$setting = item.setting) == null ? void 0 : _item$setting.call(item);
        } else if ('permission' in item) {
          return m(PermissionDropdown, {
            permission: item.permission,
            allowGuest: item.allowGuest
          });
        }
        return null;
      }
    }, 100);
    return items;
  }
  scopeControlItems() {
    return new ItemList();
  }
}
flarum.reg.add('core', 'admin/components/PermissionGrid', PermissionGrid);